import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bool, func } from 'prop-types';

import { actionCreators as accountActions, accountPropTypes } from 'redux/accountHandlers';
import { actionCreators as userFormActions, formPropType } from 'redux/userFormHandlers';
import { ROUTES } from 'constants/routes';
import { PROCEDURE } from 'constants/userForms';
import WithoutAccounts from 'app/components/WithoutAccounts';
import { gaTrackPageView } from 'services/AnalyticsService';
import withPagination from 'app/components/UTPagination/HOCs/pagination';
import { appConfig } from 'config/customization';

import AccountScene from './layout';

const relatedAccountsStep = 3;

class AccountsContainer extends Component {
  state = {
    modalIsOpen: false,
    deleteModalIsOpen: false,
    deleteAccountId: null
  };

  componentDidMount() {
    this.props.dispatch(userFormActions.getFormCategories(PROCEDURE));
    gaTrackPageView(ROUTES.ACCOUNTS);
  }

  shouldComponentUpdate = nextProps => {
    if (this.props.rows !== nextProps.rows && nextProps.addAccountInProgress) {
      return false;
    }
    return true;
  };

  handleAddAccount = () => {
    this.props.dispatch(accountActions.addAccountInit());
    this.setState({ modalIsOpen: true });
  };

  handleModalClose = () => {
    this.setState({ modalIsOpen: false });
  };

  handleDeleteAccount = async accountId => {
    await this.props.dispatch(accountActions.deleteAccount(accountId));
    this.setState({ deleteModalIsOpen: false });
  };

  handleDeleteModalOpen = accountId => {
    this.setState({ deleteModalIsOpen: true, deleteAccountId: accountId });
  };

  handleDeleteModalClose = () => {
    this.setState({ deleteModalIsOpen: false });
  };

  handleReturn = () => {
    this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
  };

  handleRelatedSuppliesModalClose = () => {
    this.props.dispatch(accountActions.showedRelatedSuppliesModal());
  };

  handleAssociateModalClose = () => {
    this.props.dispatch(accountActions.addAccountFinish());
    this.handleModalClose();
  };

  handleAssociateModalOpen = (clientNumber, relatedAccounts) => {
    this.props.dispatch(accountActions.addAccountInit());
    this.props.dispatch(accountActions.addAccountSetInitialAccount(clientNumber));
    if (relatedAccounts && relatedAccounts.length > 0) {
      this.props.dispatch(accountActions.addAccounts(relatedAccounts, false));
    }
    this.props.dispatch(accountActions.addAccountUpdateStep(relatedAccountsStep));
    this.setState({ modalIsOpen: true });
  };

  handleClick = item =>
    this.props.dispatch(
      push({
        pathname: ROUTES.ACCOUNTS_DETAIL,
        params: item.id
      })
    );

  render() {
    return (
      <AccountScene
        modalIsOpen={this.state.modalIsOpen}
        closeModal={this.handleModalClose}
        onAddAccountPress={this.handleAddAccount}
        accounts={this.props.rows}
        onReturn={this.handleReturn}
        onDeleteAccount={this.handleDeleteAccount}
        deleteModalIsOpen={this.state.deleteModalIsOpen}
        onDeleteModalOpen={this.handleDeleteModalOpen}
        onDeleteModalClose={this.handleDeleteModalClose}
        deleteAccountId={this.state.deleteAccountId}
        loading={this.props.loading && !this.props.addAccountInProgress}
        automaticDebitForm={this.props.automaticDebitForm}
        digitalBillForm={this.props.digitalBillForm}
        relatedSuppliesModalIsOpen={!this.props.relatedAccountsAlertDisplayed && this.props.relatedAccounts}
        relatedAccounts={this.props.relatedAccounts}
        onRelatedSuppliesModalClose={this.handleRelatedSuppliesModalClose}
        onAssociateModalOpen={this.handleAssociateModalOpen}
        deleteAccountLoading={this.props.deleteAccountLoading}
        onRowsRendered={this.props.onRowsRendered}
        onClick={this.handleClick}
        appending={this.props.appending}
      />
    );
  }
}

AccountsContainer.propTypes = {
  rows: accountPropTypes,
  loading: bool,
  appending: bool,
  addAccountInProgress: bool,
  automaticDebitForm: formPropType,
  digitalBillForm: formPropType,
  relatedAccounts: bool,
  relatedAccountsAlertDisplayed: bool,
  deleteAccountLoading: bool,
  onRowsRendered: func
};

const mapStateToProps = store => ({
  digitalBillForm: store.utility.digitalBillForm,
  automaticDebitForm: store.utility.automaticDebitForm,
  rows: store.account.accounts,
  loading: store.account.accountsLoading,
  addAccountInProgress: store.account.addAccountFlow.inProgress,
  relatedAccounts: store.account.currentAccount && store.account.currentAccount.related_accounts,
  relatedAccountsAlertDisplayed: store.account.relatedAccountsAlertDisplayed,
  deleteAccountLoading: store.account.deleteAccountLoading,
  userId: store.auth.currentUser.id,
  appending: store.account.appendAccountsLoading,
  accountsError: store.account.accountsError
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onMount: appConfig.shouldUseAccOptimization
    ? pageSize => dispatch(accountActions.getAccountsAsync(ownProps.userId, false, 1, pageSize))
    : () => dispatch(accountActions.getAccountsAsync(ownProps.userId)),
  append: (pageNumber, pageSize) => dispatch(accountActions.appendAccountsAsync(pageNumber, pageSize)),
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  WithoutAccounts({
    shouldShowMessage: props => props.rows.length === 0 && !props.loading,
    accountsError: props => props.accountsError
  })(withPagination(AccountsContainer, 20, !appConfig.shouldUseAccOptimization))
);
